<template>
  <div id="club-payments-container">
    <div class="print-only box-image" :style="background_color">
      <img class="print-only image" :src="user.event_logo" />
    </div>

    <Header
      :page="'payments'"
      :title_one="'payments_and_budget'"
      :action_one="'print'"
      @print="print()"
    ></Header>

    <div id="empty-space"></div>
    <template v-if="event.type_id == 1">
        <p  class="note" v-html="$t('finances.tourist_tax_note')"></p>
        <div class="bank-info-title">{{ $t('finances.bank_info.title') }}</div>
        <div class="bank-info">
            <div><span class="label">{{ $t('finances.bank_info.cc') }}</span> 2100 4535 67 2200028392</div>
            <div><span class="label">{{ $t('finances.bank_info.iban') }}</span> ES83 2100 4535 67 2200028392</div>
            <div><span class="label">{{ $t('finances.bank_info.swift') }}</span> CAIXESBBXXX</div>    
            <div><span class="label">{{ $t('finances.bank_info.entity') }}</span> CaixaBank SA </div>
            <div><span class="label">{{ $t('finances.bank_info.proprietary') }}</span> AE MICFOOTBALL</div>
            <div><span class="label">{{ $t('finances.bank_info.address') }}</span> Rambla Catalunya 78, 43500, Tortosa, España</div>
        </div>
        <div style="margin-top: 10px;">{{ $t('finances.bank_info.note') }}</div>
    </template>

    <div id="empty-space"></div>

    <div v-if="team.team" class=" print-only title-team">
      {{ team.team.name }} ({{ team.team.category.name }})
    </div>

    <div id="empty-space"></div>

    <span class="page-title">{{ $t("titles.budget") }}</span>
    <v-data-table
      id="budget"
      :headers="budget_headers"
      :items="teams"
      :no-data-text="''"
      :no-results-text="''"
      :hideActions="true"
    >
      <template v-slot:items="props">
        <tr
          v-if="
            props.item.budget_visible == 1 &&
              !props.item.is_total &&
              !props.item.is_payed
          "
          @click="openTeamBudget(props.item.id)"
        >
          <td>
            {{
              (props.item.name != "" ? props.item.name : club_name) +
                " - " +
                (props.item.category.max_age
                  ? props.item.category.max_age
                  : props.item.category)
            }}
          </td>
          <td>{{ props.item.total | toMoney }}</td>
        </tr>

        <tr v-if="props.item.is_total" class="total">
          <td class="label"></td>
          <td class="value">{{ props.item.total | toMoney }}</td>
        </tr>
      </template>
    </v-data-table>

    <span class="page-title">{{ $t("titles.payments") }}</span>
    <v-data-table
      id="payments"
      :headers="payment_headers"
      :items="teams"
      :no-data-text="''"
      :no-results-text="''"
      :hideActions="true"
    >
      <template v-slot:items="props">
        <tr
          v-if="!props.item.is_total && !props.item.is_payed"
          @click="openTeamBudget(props.item.id)"
        >
          <td>
            {{
              (props.item.name != "" ? props.item.name : club_name) +
                " - " +
                (props.item.category.max_age
                  ? props.item.category.max_age
                  : props.item.category)
            }}
          </td>
          <td>{{ props.item.payed | toMoney }}</td>
          <td v-if="props.item.remaining != ''">
            {{ props.item.remaining | toMoney }}
          </td>
          <td v-else>-</td>
        </tr>

        <tr v-if="props.item.is_payed" class="total">
          <td class="label"></td>
          <td class="value">{{ payed | toMoney }}</td>
          <td class="value">{{ (total - payed) | toMoney }}</td>
        </tr>
      </template>
    </v-data-table>

    <table id="total-summary"></table>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";

export default {
  name: "ClubPayments",

  components: {
    Header
  },

  data() {
    return {
      club_id: -1,
      club_name: "",
      teams: [],
      total: 0,
      payed: 0,
      background_color:
        "background: " + this.$store.getters["user/getUser"].event_color + ";"
    };
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    event() {
        return this.$store.getters.getCurrentEvent();
    },

    team() {
      return this.$store.getters["team/getTeam"];
    },
    budget_headers() {
      return [
        {
          text: i18n.t("team").toUpperCase(),
          value: "name",
          sortable: false
        },
        {
          text: i18n.t("params.import"),
          value: "total",
          sortable: false
        }
      ];
    },
    payment_headers() {
      return [
        {
          text: i18n.t("team").toUpperCase(),
          value: "name",
          sortable: false
        },
        {
          text: i18n.t("params.import"),
          value: "payed",
          sortable: false
        },
        {
          text: i18n.t("finances.budget.remaining"),
          value: "remaining",
          sortable: false
        }
      ];
    }
  },

  methods: {
    load() {
      var self = this;

      // admin user
      if (this.user.admin) {
        this.$store
          .dispatch("club/loadClubEvent", {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function() {
            // get club information
            self.club_id = self.$store.getters["club/getClub"].id;
            self.club_name = self.$store.getters["club/getClub"].name;

            // load teams budget
            let teams = self.$store.getters["club/getClub"].teams;
            self.load_budget_payments(teams);
          });

        // regular user
      } else {
        this.$store
          .dispatch("team/loadTeam", { team_id: this.user.team_id })
          .then(function() {
            // get club information
            self.club_id = self.$store.getters["team/getTeam"].club.id;
            self.club_name = self.$store.getters["team/getTeam"].club.name;

            // load teams budget
            let teams = self.user.teams;
            self.load_budget_payments(teams);
          });
      }
    },

    load_budget_payments(teams) {
      var self = this;

      this.$store
        .dispatch("finance/loadBudget", {
          event_id: this.user.event_id,
          type: 1,
          entity_id: this.club_id
        })
        .then(function() {
          let budget = self.$store.getters["finance/getBudget"];

          // club total and paymens
          self.total = budget.total;
          self.payed = budget.payed;

          for (let i in budget) {
            // check if data is an object
            if (typeof budget[i] == "object") {
              let team = teams[budget[i].entity_id];

              // validate if user has this team
              if (typeof team !== "undefined") {
                // team budget and payments
                team.total = budget[i].total;
                team.payed = budget[i].payed;
                team.budget_visible = budget[i].visible;

                team.budget_visible == 1
                  ? (team.remaining = team.total - team.payed)
                  : (team.remaining = "");
              }
            }
          }

          let result = ObjectToArray(teams);

          result.push({
            name: "TOTAL",
            total: self.total,
            is_total: true
          });

          result.push({
            name: "TOTAL",
            payed: self.payed,
            is_payed: true
          });

          self.teams = result;
        });
    },

    print() {
      window.print();
    },

    openTeamBudget(id) {
      let event = this.$store.getters.getCurrentEvent();
      this.$router
        .push({
          name: "payments",
          params: {
            team_id: id,
            event: this.$root.formatEventUrl(event.name, event.edition)
          }
        })
        .catch(err => {});
    }
  },

  watch: {
    $route: "load"
  },

  created() {
    this.load();
  }
};
</script>

<style lang="scss">
.print-only {
  display: none;

  &.box-image {
    margin-bottom: 10px;
    width: calc(100%);
    height: 80px;
    overflow: auto;
    text-align: center;
  }

  &.image {
    height: calc(100% - 10px) !important;
    margin: 5px auto !important;
  }
}

#club-payments-container {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;

  .bank-info-title {
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .label {
    font-weight: bold;
    margin-right: 10px;
  }

  #empty-space {
    height: 50px;
  }

  .descriptions,
  .search {
    margin-top: 25px;
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
  }

  .search {
    width: 100%;
    display: inline-block;
    input {
      @include background(
        $image: img("magnify.svg"),
        $position: right 5px center,
        $size: 22px
      );
      padding: 10px 30px 10px 15px;
      border: 1px solid $secondary-color;
      outline: none;
      font-size: 11pt;
      border-radius: 3px;
      color: $dark-color;
      float: right;

      &::placeholder {
        color: $dark-color;
        opacity: 0.5;
      }
    }
  }

  #payments,
  #budget {
    margin-top: 20px;
  }

  #payments {
    // margin-top: 10px;

    th {
      padding: 6px 10px 0 15px !important;
    }

    .v-toolbar__title {
      color: white;
    }
    .total {
      border-top: 3px solid #828aa0;
      td {
        font-weight: bold;
        font-family: Roboto-Bold;
        padding: 15px 10px;
        font-size: 16px;
        text-transform: uppercase;
      }
    }
  }

  #budget {
    margin-bottom: 50px;

    th {
      padding: 6px 10px 0 15px !important;
      border-bottom: 0px solid #fff;
    }
    td {
      background-color: #fff;
      padding: 10px;
    }

    .v-datatable__progress {
      display: none !important;
    }
    .category {
      padding: 10px;
      background-color: #f7f7f7;
      color: #4f5462;
      text-transform: uppercase;
      font-family: AvantGarde-Bold;
    }

    .total {
      border-top: 3px solid #828aa0;
      td {
        font-weight: bold;
        font-family: Roboto-Bold;
        padding: 15px 10px;
        font-size: 16px;
        text-transform: uppercase;
      }

      td:nth-child(1) {
        width: 65%;
      }

      td:nth-child(2) {
        width: 35%;
      }
    }

    .input {
      border: 1px solid #ccc;
      padding: 5px 10px;
      border-radius: 3px;
      width: 75px;
    }

    .label {
      padding-right: 35px !important;
    }

    .label {
      text-align: right;
      font-size: 14px;
      text-transform: uppercase;
    }

    .value {
      font-weight: bold;
      font-family: Roboto-Bold;
      font-size: 16px;
    }
  }

  #total-summary {
    width: 100%;
    border-top: 3px solid #828aa0;
    padding-top: 10px;
    margin-bottom: 50px;

    th {
      height: 15px;
    }

    .row {
      width: 100%;
      overflow: hidden;
      padding: 5px;

      td {
        padding: 5px 24px;

        &.label {
          text-align: right;
          font-size: 14px;
          text-transform: uppercase;
        }

        &.value {
          font-weight: bold;
          font-family: Roboto-Bold;
          font-size: 16px;
        }
      }

      &.exceeded {
        td {
          &.label {
            color: #d42525;
          }

          &.value {
            color: #d42525;
          }
        }
      }
    }
  }

  #campus_payments {
    overflow: hidden;
  }

  .mainButton {
    float: right;
    width: auto;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    border-radius: 3px;
    // text-transform: uppercase;
    transition: all 0.5s;
    background-color: $main-color;
    color: #fff;
    height: 40px;
    margin: 0;
    margin-left: 6px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    border: 1px solid #fc8926;
    &:hover {
      background-color: #e78026;
      border-color: #e78026;
    }
  }
}

@include media("<=desktop") {
  #club-payments-container {
    #budget {
      td {
        padding: 5px;
      }
    }

    #payment {
      td {
      }
    }

    #total-summary {
      margin-top: 20px;
    }

    .label,
    .value {
      padding: 0;
      width: auto;
    }

    .empty {
      display: none;
    }
  }
}

@media print {
  .print-only {
    display: block !important;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    background-color: white !important;
    color-adjust: exact !important;
  }

  .mainButton {
    display: none !important;
  }

  .toogle-content {
    display: none !important;
  }

  #topbar {
    display: none !important;
  }

  #club-payments-container {
    #header {
      display: none;
    }

    .title-team {
      position: relative;
      top: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family: AvantGarde-Bold;
      font-size: 28px !important;
      line-height: 40px;
      color: #222;
    }

    .left {
      padding-left: 0px !important;
    }

    .actions {
      display: none !important;
    }

    #total-summary {
      .value {
        text-align: center;
      }
    }
  }
}
</style>
